import ease from '../ease/';

export default (function (start, duration, easing) {

  var prog = (Date.now() - start) / duration;
  return ease[easing](prog);
});